<template>
	<div class="nav-tab-group" :class="{'actions-menu':showTabMenu}">
		<i v-if="showTabMenu" class="fa fa-ellipsis-v fa-fw icon-button actions-menu-button" v-on:click.prevent="tabMenuToggle"></i>
		<sub-menu v-if="actionsMenuOpen"
			class="actions-menu-dropdown"
			:items="actionMenuItems"
			v-on:closeMenu="actionsMenuOpen = false"
			v-on:linkClick="actionsMenuNavigate"
			v-on:itemClick="actionsMenuNavigate">
		</sub-menu>
		<ul class="tab-buttons" ref="tabButtons" id="tab-buttons-ul" v-if="tabsFilteredForPerms.length > 0 && !showTabMenu">
			<slot></slot>

			<li v-for="(tab,tabIndex) in tabsFilteredForPerms" v-if="!('more' in tab) || !tab.more || tabIndex == activeIndex"
				:class="{active: 
					(
						typeof activeIndex != 'undefined'
						&& 
						tabIndex == activeIndex
					)
					||
					(
						typeof activeIndex == 'undefined'
						&&
						(
							('tab' in $route.params && $route.params.tab == tab.path) || 
							$route.path.indexOf(tab.path) >= 0 || 
							$route.path.indexOf(tab.click) >= 0 ||
							tabIndex == activeIndex
						)
					)
				}">
				<router-link v-if="'path' in tab" :to="tab.path">
					<i class="fa fa-fw" :class="tab.icon" style="margin-right: 5px"></i>
					<span class="tab-label">{{ tab.label }}</span>
					<span v-if="tab.bubble > 0" class="notification-bubble">{{ tab.bubble }}</span>
				</router-link>
				<a v-else-if="'click' in tab" href="#" v-on:click.prevent="tabClick(tab.click)">
					<i class="fa fa-fw" :class="tab.icon" style="margin-right: 5px"></i>
					<span class="tab-label"> {{ tab.label }}</span>
					<span v-if="tab.bubble > 0" class="notification-bubble"> {{ tab.bubble }}</span>
				</a>
			</li>

			<li v-if="hasMore">
				<a href="#" v-on:click.prevent="moreTabVisible = true">
					<span class="tab-label">More...</span>
				</a>
			</li>

		</ul>

		<sub-menu v-if="hasMore && moreTabVisible" 
			:heading="moreHeading ? moreHeading : 'More Tabs'"
			class="more-menu"
			:items="moreTabs"
			v-on:closeMenu="moreTabVisible = false"
			v-on:linkClick="subMenuLinkClick">
		</sub-menu>
		
		<i v-if="scrollRightArrowVisible" class="fa fa-chevron-right scroll-arrow-indicator"></i>
		<i v-if="scrollLeftArrowVisible" class="fa fa-chevron-left scroll-arrow-indicator"></i>
		<div style="clear:both"></div>
	</div>

</template>

<script type="text/javascript">
import SubMenu from "@/layout_fragments/SubMenu"

export default {
	name: "NavTabs",
	components: {
		SubMenu
	},
	props: [
		"tabs",
		"activeIndex",
		"moreHeading",
		"extraActionMenuItemsStart",
		"extraActionMenuItemsEnd",
		"mobileBreakpoint",
		"addonAppsLocation", //if set, this sets the UI location for addon apps and adds the "Apps" tab if apps exist
		"addonAppsLink"
	],
	data() {
		return {
			scrollLeftArrowVisible: false,
			scrollRightArrowVisible: false,
			moreTabVisible: false,
			actionsMenuOpen: false
		}
	},
	watch: {
		tabsFilteredForPerms() {
			this.$bus.$emit("navTabsChange",this.tabsFilteredForPerms)
		}
	},
	computed: {
		actionMenuItems() {
			let items = []

			if (this.extraActionMenuItemsStart)
				items = this.extraActionMenuItemsStart

			items = items.concat(this.tabsFilteredForPerms)

			if (this.extraActionMenuItemsEnd)
				items = items.concat(this.extraActionMenuItemsEnd)

			return items
		},
		tabsFilteredForPerms() {
			let tabs = this.cloneObj(this.tabs)

			if (this.addonAppsLocation && this.addonAppsTabNavItem(this.addonAppsLocation)) 
				tabs.push(this.addonAppsTabNavItem(this.addonAppsLocation))	

			let filtered = this.filterNavForPerms(tabs)

			if (filtered.find(tab => 'more' in tab && tab.more) && filtered[filtered.length-1].label == "Apps")
				filtered[filtered.length-1].more = true

			return filtered
		},
		moreTabs() {
			return this.tabsFilteredForPerms.filter(tab => 'more' in tab && tab.more).map(tab => {
				tab.text = tab.label

				if ("path" in tab)
					tab.link = tab.path
				if ("click" in tab)
					tab.link = tab.click

				return tab
			})
		},
		hasMore() {
			if (this.tabsFilteredForPerms.find(tab => 'more' in tab && tab.more))
				return true

			else
				return false
		},
		showTabMenu() {
			if (window.innerWidth < this.mobileBreakpoint)
				return true
			else
				return false
		}
	},
	methods: {
		addonAppsTabNavItem(uiLocation) {
			if (this.$store.company.AddonApp) {
				let hasAppsHere = this.$store.company.AddonApp.find(app => app.ui_location == uiLocation)

				if (hasAppsHere) {
					return {
						label: "Apps",
						icon: "fa-th-large",
						path: this.addonAppsLink
					}
				}
			}
			return null
		},
		tabMenuToggle() {
			this.actionsMenuOpen = !this.actionsMenuOpen
		},
		tabClick(tabClick) {
			this.moreTabVisible = false
			this.$emit("tabClick",tabClick)
		},
		subMenuLinkClick(item) {
			if ("path" in item)
				this.$router.push(item.path)
			else if ("link" in item)
				this.$router.push(item.link)
		},
		actionsMenuNavigate(item) {
			if ("path" in item)
				this.$router.push(item.path)
			else {
				this.actionsMenuOpen = false
				this.$emit("buttonClick",item)
			}
		},
		scrollActiveTabIntoView() {
			let container = this.$refs.tabButtons

			if (container) {

				let buttonTotalWidths = 0
				let activeTab, requiredScrollValue
				Object.keys(container.children).forEach(key => {
					if (container.children[key].className.indexOf("active") >= 0) {
						//this is the active tab, make sure it is scrolled into view
						activeTab = container.children[key]
						requiredScrollValue = buttonTotalWidths
					}

					buttonTotalWidths += container.children[key].clientWidth
				})

				container.scrollLeft = requiredScrollValue
			}
		},
		setScrollIndicatorVisiblity() {
			let container = this.$refs.tabButtons

			if (container) {

				let buttonTotalWidths = 0
				Object.keys(container.children).forEach(key => {
					buttonTotalWidths += container.children[key].clientWidth
				})

				if (container.clientWidth <  buttonTotalWidths && container.scrollLeft > 0)
					this.scrollLeftArrowVisible = true
				else
					this.scrollLeftArrowVisible = false

				if (container.clientWidth < buttonTotalWidths && buttonTotalWidths - container.scrollLeft - 10 > container.clientWidth) //-10 for some extra margin to make the button disappear sooner
					this.scrollRightArrowVisible = true
				else
					this.scrollRightArrowVisible = false
			}
		}
	},
	mounted() {
		this.isMounted = true

		this.setScrollIndicatorVisiblity()
		this.scrollActiveTabIntoView()

		let vm = this

		let container = this.$refs.tabButtons

		if (container)
			container.addEventListener("scroll",vm.setScrollIndicatorVisiblity)
	},
	beforeDestroy() {
		let container = this.$refs.tabButtons

		if (container)
			container.removeEventListener("scroll",this.setScrollIndicatorVisiblity)
	}
}
</script>

<style type="text/css" scoped>

	.nav-tab-group {
		min-height: 5px; /*for in case there are no nav-tabs at all */
		position: relative;
	}

	.nav-tab-group.actions-menu {
		text-align: right;
		display: inline-block;
		width: 30px;
		margin-right: 10px;
	}

	.actions-menu-button {
		text-align: center;
		text-decoration: none;
		cursor: pointer;
		padding-top: 4px;
	}

	.actions-menu .actions-menu-dropdown {
		margin-top: -10px;
		margin-right: -10px;
	}

	.tab-buttons {
		list-style: none;
		margin: 0;
		position: relative;
		padding: 0;
		display: flex;
		flex-direction: row;
		margin-top: -0;
		margin-bottom: -0;
		min-height: 50px;
		align-items: stretch;
		overflow-x: auto;
	}

	.tab-buttons::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	.tab-buttons li {
		flex-grow: 1;
		font-size: 11pt;
		text-align: center;
		margin-top: 0px;
		margin-bottom: -0;
		/*border-top: 2px solid rgba(255,255,255,0.5);
		border-top: 2px solid #CFD8DC;*/
	}

	/*.tab-buttons li.active {
		border-top: 2px solid #28a745;
	}*/

	.tab-buttons li a {
		display: block;
		padding: 10px;
		height: 100%;
		padding-top: 15px;
		text-decoration: none;
		/*background-color: rgba(255,255,255,0.5);
		background-color: #CFD8DC;*/
		background-color: transparent;
		border-left: 1px solid rgba(255,255,255,0.65);
		border-left: #CFD8DC;
		color: #455A64;
		color: #88867F;
		text-transform: uppercase;
	}

	.tab-buttons li a:hover {
		text-decoration: none;
		background-color: white;
		color: #004E5C
	}

	.nav-tab-group .router-link-exact-active, .nav-tab-group .active a {
		border-left: 3px solid #003540;
		border-left: none;

		background-color: #fdfdfd;
		/*background-color: white;*/
		color: var(--brand-primary-color);
	}

	.notification-bubble {
		border-radius: 50%;
		background-color: Red;
		color: white;
		padding: 3px;
		font-size: 8pt;
		height: 18px;
		width: 18px;
		display: inline-block;
		text-align: center;
		padding-top: 2px;
		position: absolute;
		top: 0;
		right: 0;
		box-shadow: 0.5px 0.5px 2px #404040;
		font-weight: bold;
	}

	.button-bar .tab-buttons li {
		position: relative;
	}

	.scroll-arrow-indicator {
		position: absolute;
		top: 15px;
		opacity: 0.4;
		font-size: 30px;
	}

	.scroll-arrow-indicator.fa-chevron-left {
		left: -10px;
	}

	.scroll-arrow-indicator.fa-chevron-right {
		right: -10px;
	}

	.more-menu {
		top: 100%!important;
		position: absolute!important;
	}

	@media (max-width: 767px) {

		.nav-tab-group {
			width: calc(100% - 10px);
			margin-left: 0;
			margin-right: 0;
		}

		.tab-buttons {
			height: auto;
		}

		.tab-label {
			display: block;
		}

		.more-menu {
			top: 80px!important;
		}

	}

	@media (max-width: 500px) {
		.tab-label {
			font-size: 9pt;
		}
	}

	@media (max-width: 360px) {

	}
</style>